
export const GetAllUsersAutocomplete = async (page = 1, limit = 10) => {
  const API_URL = process.env.REACT_APP_API_URL + "user/";
  try {
    const response = await fetch(
      `${API_URL}?page=${page}&limit=${limit}` 
    );

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      status: response.status,
      data: data.response?.data || data  
    };
  } catch (error) {
    console.error("[GetAllUsersAutocomplete] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500  
    };
  }
};




export const GetAllPackegesAutocomplete = async (page = 1, limit = 10) => {
  const API_URL = process.env.REACT_APP_API_URL +  "package/";
  try {
    const response = await fetch(
      `${API_URL}?page=${page}&limit=${limit}`  
    );

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      status: response.status,
      data: data.response?.data || data  
    };
  } catch (error) {
    console.error("[GetAllUsersAutocomplete] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500  
    };
  }
};




export const GetAllReservationsByDateApi = async ({ 
  page = 1, 
  limit = Number.MAX_SAFE_INTEGER,
  dateOfReservation ="" ,
  isPaid=true
}) => {
  const API_URL = process.env.REACT_APP_API_URL + "reservations/";
  try {
    // بناء URL مع المعاملات المطلوبة فقط
    let url = `${API_URL}?page=${page}&limit=${limit}`;
    
    // إضافة معامل التاريخ فقط إذا كان موجوداً وليس فارغاً
    if (dateOfReservation && dateOfReservation.trim() !== "") {
      url += `&dateOfReservation=${encodeURIComponent(dateOfReservation)}`;
    }
    
    // إضافة معامل الدفع فقط إذا كان true (لتجنب فلترة الحجوزات غير المدفوعة)
    if (isPaid === true) {
      url += `&isPaid=${isPaid}`;
    }
    
    console.log("🌐 API Request URL:", url);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    // تحسين معالجة البيانات لضمان الاتساق
    let responseData = [];
    
    if (data) {
      if (Array.isArray(data)) {
        responseData = data;
      } else if (data.response && Array.isArray(data.response.data)) {
        responseData = data.response.data;
      } else if (data.response && Array.isArray(data.response)) {
        responseData = data.response;
      } else if (Array.isArray(data.data)) {
        responseData = data.data;
      } else if (data.reservations && Array.isArray(data.reservations)) {
        responseData = data.reservations;
      }
    }
    
    return {
      status: response.status,
      data: responseData,
      total: data.total || responseData.length,
      page: data.page || page,
      totalPages: data.totalPages || Math.ceil((data.total || responseData.length) / limit)
    };
  } catch (error) {
    console.error("[GetReservationsByDate] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500,
      total: 0,
      page: 1,
      totalPages: 0
    };
  }
};


